<!DOCTYPE html>
@if (!narratorShow) {
  <div>
    <div class="narrator-wrapper narrator-middle-wrapper" [class.tip-discount-voucher-store-container]="isTipDiscountVoucherStore" [class.tip-jackpot-trigger-container]="isTipJackpotTrigger">
      @if (showCloseIcon) {
        <div class="close-ico" (click)="closeNarrator(narratorData)">
          <img src="../../../assets/images/narrator-tips/narr-close.png" alt="top-close"/>
        </div>
      }
      @if (cardImage && narratorData?.setting?.page_name!='menu') {
        <div
      [ngClass]="narratorData?.setting?.image_position === 'top-left' ? 'menu-wrapper menu-top-left' 
      : narratorData?.setting?.image_position === 'bottom-left' ? 'menu-wrapper menu-bottom-left' 
      : narratorData?.setting?.image_position === 'bottom-right' ? 'menu-wrapper menu-bottom-right' : 'card-img-wrapper' "
      [class.tip-discount-voucher-store]="isTipDiscountVoucherStore"    
      >
          <div [ngClass]="narratorData?.setting?.image_pulse ? 'menu-img-wrapper' : ''">
            <img [src]="narratorData?.content?.[narratorIndex]?.image_url" alt="menu-img"/>
          </div>
        </div>
      }
      <div
      [ngClass]="
      narratorData?.setting?.page_name === '' ? 'avatar-wrapper-gameFeed':
        narratorData?.setting?.screen_position === 'top' && !cardImage
          ? 'avatar-outer-top-wrapper'
          : narratorData?.setting?.screen_position === 'top' && cardImage && narratorData?.setting?.image_position ? 'avatar-outer-top-wrapper' : narratorData?.setting?.screen_position === 'bottom'
          ? 'avatar-bottom-wrapper'
          : narratorData?.setting?.screen_position === 'middle' && !cardImage ? 'avatar-outer-wrapper' :  narratorData?.setting?.screen_position === 'middle' && cardImage && narratorData?.setting?.image_position ? 'avatar-outer-wrapper' : 'avatar-wrapper-homeFeed'
      "
        Class="ion-no-padding"
        >
        @if (displayAvatar) {
          <div class="avatar-wrapper">
            <div class="avatar-img">
              <img src="../../../assets/images/narrator-tips/avatar.svg" alt="avatar-image"/>
            </div>
            <div class="typewriter">
              <p>
                <span id="descrip">
                  <span class="text_1 type" style="--n: 200">
                    @if (displayTypewriterText) {
                      <span #narratorContent [innerHTML]="displayTypewriterText" class="light-text"></span>
                    }
                  </span>
                </span>
              </p>
            </div>
            @if (nextButton) {
              <div class="next-icon">
                <span
                  (click)="nextNarratorTip(narratorData?.content)"
                  >
                  <img class="next-img" src="../../../assets/images/narrator-tips/narr-arrow.png" alt="next-arrow-img" />
                </span>
              </div>
            }
          </div>
        }
        @if (narratorData?.setting?.page_name == 'menu' && cardImage) {
          <div class="feature-wrapper" [ngClass]="narratorData?.setting?.screen_position == 'middle' ? 'feature-wrapper-middle' : narratorData?.setting?.screen_position == 'bottom' ? 'feature-wrapper-bottom' : 'feature-wrapper' ">
            <div [ngClass]="narratorData?.setting?.image_pulse ? 'feature-img-wrapper' : ''">
              <img src="../../../assets/images/narrator-tips/feature.png" alt="feature-image" />
            </div>
          </div>
        }
      </div>
      @if (showJackpotTriggerCta) {
        <div class="setup-now-btn-wrapper">
          <button type="button" class="setup-now-btn" (click)="setupJackpotTriggerNow()">
            {{ "store.setup_now" | translate }}
          </button>
        </div>
      }
    </div>
  </div>
}
